import { RootState } from "@/shared/types";
import { IGetManyInvoicesParams, IInvoicesData } from "./types/interfaces";

export const selectParams = (state: RootState): IGetManyInvoicesParams =>
  state.invoices.params;

export const selectInvoices = (state: RootState): IInvoicesData =>
  state.invoices.data;
